import { shuffleArray } from '../helpers/array-helpers';

const thoughts = [
  'My other website is on Geocities',
  'Coding... Coding...',
  'Tea time: 3pm, every day',
  'Rome wasn\'t built in a day, but Javascript was',
  'Looks like good coding weather today'
]

const randomThoughts = shuffleArray(thoughts)

export default randomThoughts